/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { ConfirmationCssClasses, NoticeReadingTitles } from "../../../../../../../../../_helpers/Helpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      ConfirmationCssClasses[row.isRead]
    } label-inline`}
  >
    {NoticeReadingTitles[row.isRead]}
  </span>
);